'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.createEventString = createEventString;
exports.default = logCategoryActionLabel;

var _webApiClientSingleton = require('../webApiClientSingleton');

var _webApiClientSingleton2 = _interopRequireDefault(_webApiClientSingleton);

var _logging = require('../player/constants/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createEventString(event) {
  var category = event.category || _logging.categories.ad;

  return [category, event.action, event.label, event.value].join('|').replace(/\|+$/, ''); // removes any trailing `|`
}

function logCategoryActionLabel(event, moreParams) {
  var params = (0, _extends3.default)({
    c: 'eventlist',
    render: 'json'
  }, moreParams);

  var eventString = createEventString(event);
  var body = 'event1=' + eventString;

  _webApiClientSingleton2.default.instance.logging.eventLog(params, body);
}
//# sourceMappingURL=logCategoryActionLabel.js.map